import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=11e05a06"
import script from "./ads.vue?vue&type=script&lang=js"
export * from "./ads.vue?vue&type=script&lang=js"
import style0 from "./ads.vue?vue&type=style&index=0&id=11e05a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports